import {
    ButtonWithIcon,
    HorizontalContainer,
    HorizontalDivider,
    VerticalContainer,
} from '@/components';
import { CallIcon } from '@/components/Icons';

import { R } from '@/caregiverSpace/resources/Texts.resx';

import type { PhoneCallStatus } from '../lib/PhoneCallHandler';
import { useCallTimer } from '../lib/useCallTimer';

type PhoneCallActiveViewProps = {
    onEndCall: () => void;
    callStatus: PhoneCallStatus;
};

export const PhoneCallActiveView = ({
    onEndCall,
    callStatus,
}: PhoneCallActiveViewProps) => {
    const isConnected = callStatus === 'Connected';
    const { formattedTime } = useCallTimer(isConnected);

    return (
        <VerticalContainer spacing="md">
            <HorizontalDivider />
            <h3>{R.PhoneCallActiveTitle}</h3>
            <p>{R.PhoneCallActiveDescription}</p>
            <HorizontalContainer className="items-center justify-between">
                <div>
                    {isConnected ? (
                        formattedTime
                    ) : (
                        <span className="animate-pulse">
                            {R.PhoneCallRinging}
                        </span>
                    )}
                </div>
                <ButtonWithIcon
                    icon={<CallIcon />}
                    variant="primary"
                    onClick={onEndCall}
                    className="bg-(--color-text-danger)"
                >
                    {R.EndCall}
                </ButtonWithIcon>
            </HorizontalContainer>
        </VerticalContainer>
    );
};
